import 'popper.js';
import 'chart.js';
import bsBreakpoints from 'bs-breakpoints'
import 'regenerator-runtime/runtime'

import Vue from 'vue';
import vuedl from 'vuedl'
import '@/lib/filters'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import breakpoints from '@eli5/bootstrap-breakpoints-vue'

import helpers from '@/lib/helpers'
import VuePageTransition from 'vue-page-transition'
import PortalVue from 'portal-vue'
import store from './store'
import router from './router'
import App from "./app.vue";

import {library} from '@fortawesome/fontawesome-svg-core'
import {faEbay} from '@fortawesome/free-brands-svg-icons'
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "chart.js/dist/Chart";
import "../node_modules/vue-multiselect/dist/vue-multiselect.min.css"
import './style/app.css'

import * as Sentry from "@sentry/vue";

library.add(faEbay, fas, far)

window.accounting = require('accounting');
window.bsBreakpoints = bsBreakpoints;

Vue.component('files', () => import('./components/files/files.vue'))
Vue.component('notes', () => import('./components/notes/notes.vue'))
Vue.component('base-page', () => import ('./components/layout/base-page.vue'))
Vue.component('photo-upload', () => import('./components/photos/photo-upload'))
Vue.component('photo-capture', () => import('./components/photos/photo-capture'))
Vue.component('mode-selector', () => import('./components/layout/mode-selector.vue'))
Vue.component('photo-gallery', () => import('./components/photos/photo-gallery'))

Vue.component('auction-quick-edit', () => import('./components/auction/auction-quick-edit'))
Vue.component('modal-portal', () => import('./components/layout/modal-portal.vue'))
Vue.component('auction-repricer', () => import('./components/auction/auction-repricer'))

Vue.component('modal', () => import('./components/layout/modal'))
Vue.component('toolbar-scroll', () => import('./components/layout/toolbar-scroll'))
Vue.component('form-card', () => import('./components/form/form-card.vue'))
Vue.component('form-row', () => import('./components/form/form-row.vue'))
Vue.component('form-divider', () => import('./components/form/form-divider.vue'))
Vue.component('modal-row', () => import('./components/layout/modal-row'))
Vue.component('form-select-remote-search', () => import('./components/form/form-select-remote-search.vue'))
Vue.component('form-select', () => import('./components/form/form-select.vue'))
Vue.component('audit-resolve', () => import('./components/audit/audit-resolve.vue'))
Vue.component('offer', () => import('./components/offer/offer.vue'))
Vue.component('message', () => import('./components/message/message.vue'))
Vue.component('message-templates', () => import('./components/message/message-templates.vue'))
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('modal-task-log', () => import('./components/layout/modal-task-log.vue'))
Vue.component('chip-selector', () => import('./components/layout/chip-selector.vue'))
Vue.component('item-chooser', () => import('./components/item/item-chooser.vue'))
Vue.component('form-currency', () => import('./components/form/form-currency.vue'))
Vue.component('tag', () => import('./components/layout/tag.vue'))
Vue.component('text-copy', () => import('./components/layout/text-copy.vue'))
Vue.component('lookup', () => import('./components/layout/lookup/lookup.vue'))
Vue.component('transaction', () => import('./components/transaction/transaction.vue'))
Vue.component('order-add-item-by-auction', () => import('./components/order/order-add-item-by-auction.vue'))
Vue.component('form-section-header', () => import('./components/form/form-section-header.vue'))

Vue.mixin({
    methods: helpers,
    computed: {
        record() {
            return this.$store.state.record.active
        }
    }
})

Vue.use(VuePageTransition)
Vue.use(CKEditor);
Vue.use(breakpoints)
Vue.use(PortalVue)
Vue.use(BootstrapVue, {
    formControls: {
        disabled: undefined,
        required: false,
        form: undefined,
        autofocus: false,
        plain: false,
        size: 'sm'
    },
})
Vue.use(BootstrapVueIcons)

window.axios = require('axios');

Chart.defaults.global.defaultFontFamily = '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
Chart.defaults.global.defaultFontColor = '#292b2c';

Vue.use(vuedl,
    {
        context: {store, router}
    })


if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        dsn: "https://5599fa19909a0e480794d911da2f5468@o4508876282068992.ingest.us.sentry.io/4508876284100608",
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [ /^https:\/\/oms\.ntc-tech\.com\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        ignoreErrors: [
            'PrintError',
            'RemoteError',
            'NavigationDuplicated'
        ]
    });

    if (store.getters.isAuthenticated)
        Sentry.setUser({id: store.state.auth.user, username: store.state.auth.name})

}

window.vue = new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
